import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'core-js'
import 'antd/dist/antd.css';
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import {HashRouter} from 'react-router-dom'
ReactDOM.render(
  <HashRouter >
    <App />
  </HashRouter>,
   document.getElementById('root')
);